import React from 'react';
import './Item.css';

const Item = (props) => {
  // console.log(props.vdo.id.videoId);
  // console.log(props.vdo.snippet?.title); 
  const url = `https://www.youtube.com/embed/${props.vdo.id.videoId}?rel=0`
  // console.log(url);
  return (
    <div className='video'>
      <div className="card card-custom glass bg-slate-300">
        <figure>
          <iframe id="ytplayer"
            type="text/html" 
            width="400" 
            height="225"
            src={url}
            title={props.vdo.snippet?.title}
            frameBorder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen>
          </iframe>
        </figure>
        <div className="card-body py-5 px-3 h-60">
          <h2 className="card-title text-black">{props.vdo.snippet?.title}</h2>
          <p className='text-black'>{props.vdo.snippet?.description}</p>
        </div>
      </div>
    </div>
  );
};

export default Item;